/* eslint-disable */
/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Feature0 from './Feature0';
import Content5 from './Content5';
import { Feature00DataSource, Content50DataSource } from './data.source';
import './less/antMotionStyle.less';
import Banner3 from "../TalentStrategy/Banner3";
import { Banner30DataSource } from "./data.source";
import Footer1 from "../Home/Footer1";
import Nav0 from "../Home/Nav0";
import { Footer10DataSource, Nav00DataSource } from "../Home/data.source";
import BreadcrumbCon from '../components/BreadcrumbCon';
import TextCon from '../components/TextCon';

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const { location } = window;

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,

        };
    }

    componentDidMount() {
        // 适配手机屏幕;
        enquireScreen((b) => {
            this.setState({isMobile: !!b});
        });

        setTimeout(() => {
            this.scroll();
        }, 1000);
    }

    scroll() {
        let key = window.location.hash.split("?")[1];
        let eleId='container101';
        switch (key) {
            case 'key=1':eleId='container101';
                break;
            case 'key=2':
                eleId='container102';
                break;
            case 'key=3':
                eleId='container103';
                break;
            case 'key=4':
                eleId='container104';
                break;
            case 'key=5':
                eleId='container105';
                break;
        }
        console.log('eleId',eleId);
        let anchorElement = document.getElementById(eleId);
        if(anchorElement) {
            anchorElement.scrollIntoView(
                {behavior: 'smooth'}
            );
        }
    }

    render() {
        let textList = [
            "南京雨后地软环境技术有限公司是专业从事大气科学、环境科学、生态学及计算机应用等相关学科研究、技术应用及咨询服务的高新技术企业、专精特新中小企业，是气象、环境和生态领域数据分析应用、数值预报预警及综合辅助决策的系统解决方案专家。",
            // "南京雨后地软环境技术有限公司是专业从事大气科学、环境科学、生态学及计算机应用等相关学科研究、技术应用及咨询服务的高新技术企业，是气象、环境和生态领域数据分析应用、数值预报预警及综合辅助决策的系统解决方案专家。",
            "公司成立于2016年，总部坐落于江苏南京，拥有长期纵深研究CESM、IAP AGCM、RegCM、WRF、WRF-Chem、CMAQ、CAMx、SMOKE、MEGAN、HYSPLIT、FLEXPART、CLM、SWAT、EFDC等气象、水文、空气质量、生态等数值模式的资深国际团队。拥有“高新技术企业”、“江苏省民营科技企业”、“软件企业”、“软件产品”、“AAA级资信等级”等认证、50余项软件著作权及专利。公司始终秉承“至诚至善，合作共赢”的价值观，携手客户、不懈进取、集智攻关，在气象灾害预警、大气、土壤和水环境污染防控、生态环境保护建设等领域创新、引领、启未来！",
        ];

        let IndustryList = [
            {
                img: "img/solution.png", title: "更全面的分析诊断",
                text: "更准确的预报预警",
            },
            {
                img: "img/technicalTeam.png", title: "更可靠的解析溯源",
                text: "更科学的决策支持",
            },
            {
                img: "img/successfulCase.png", title: "更形象的结果展示",
                text: "更专业的运维服务"
            }
        ];

        const introduce = <p style={{lineHeight:"80px"}}>公司简介 / Company Introduction</p>
        const children = [
            <Nav0
                id="Nav0_0"
                key="Nav0_0"
                dataSource={Nav00DataSource}
                isMobile={this.state.isMobile}
            />,
            <Banner3
                id="Banner3_0"
                key="Banner3_0"
                dataSource={Banner30DataSource}
                isMobile={this.state.isMobile}
            />,
            <div className={"container"}

                 style={{ height: '5vh', }}>
                <BreadcrumbCon pageName={"关于我们"} pagePath={"/aboutUs"}/>
            </div>,
            <div className={"container"}
                 key={'container101'}
                 id={'container101'}
                 style={{ minHeight: '40vh', }}>
                <TextCon title={introduce}
                         textList={textList}
                />
            </div>,

            /*  <Feature0
             id="Feature0_0"
             key="Feature0_0"
             dataSource={Feature00DataSource}
             isMobile={this.state.isMobile}
             />,*/
            <div className={"container"}
                 key={'container102'}
                 id={'container102'}
                 style={{minHeight:"40vh"}}>
                <TextCon title={"团队实力 / Company Strength"}
                />
                <div style={{ display: 'flex', padding:50,marginBottom: 30,backgroundColor:"#f3f4f6" }}>

                    <div style={{width:"50"}}>
                         <img src="/img/TeamStrength.png" style={{ width: '86%',position:"relative",left:"21%",top:"10%" }}/>
                    </div>

                    <div style={{ width: '70%', background: '#fff', padding: 50 }}>
                        <div style={{ fontSize: '20px', marginBottom: '30px' }}>专业的技术团队</div>
                        <div style={{ fontSize: '14px', lineHeight: '30px' }}>
                            公司技术专家在气象、环境、生态等行业领域具备精深的专业知识和丰富的项目实践经验，
                            实现了数值预报、模型研发应用、输入资料同化、细颗粒物和臭氧污染物来源数值模拟解析、监管应用等重要领域的产品紧跟
                            国际前沿并有特色的技术突破，效率更高、更加适合中国国情。核心团队成员曾组织实施了多项国家级和省部级项目，获得多项省部级科技进步奖。
                            公司重视人才的引进与培训，并拥有一流的专家辊纹团队进行长期指导和支持，使公司人才、技术、管理水平与国际先进水平同步。
                        </div>
                    </div>
                </div>
            </div>,
            <div className={"container"}
                 key={'container103'}
                 id={'container103'}
                 style={{ minHeight: '40vh' }}>
                <TextCon title={"服务优势 / Serve Advantage"}
                />
                <div style={{ display: 'flex', height: '40vh' }}>
                    {IndustryList.map((ii, index) => {
                        return <div style={{
                            width: '31%', margin: 20,
                            background: 'url(' + ii.img + ')no-repeat',
                            backgroundSize: '100% 100%'
                        }} key={index}>
                            <div style={{ color: 'white', padding: '20px', marginTop: '14vh' }}>
                                <div
                                    style={{ textAlign: 'center', fontSize: 16, fontWeight: 600 ,letterSpacing:4}}>{ii.title}</div>
                                <div
                                    style={{ textAlign: 'center', fontSize: 16, fontWeight: 600,marginTop:10,letterSpacing:4}}>{ii.text}</div>
                            </div>
                        </div>
                    })}
                </div>

            </div>,


            <div className={"container"} id={'container104'} key={'container104'}>
                <TextCon title={"资质荣誉 / Company Profile"}
                />
                <img src="/img/certificate4.png" style={{ width: '60%',marginLeft:"20%" }}/>
                <div
                    style={{ fontSize: 24, textAlign: 'center', color: '#aaa', padding: ' 0 30px 30px', letterSpacing: '0.3em' }}>&lt;
                    软著证书&gt;</div>
                <img src="/img/honor.png" style={{ width: '100%' }}/>
                <img src="/img/patent.png" style={{ width: '100%', marginTop: 10 }}/>
                <div
                    style={{ fontSize: 24, textAlign: 'center', color: '#aaa', padding: '50px', letterSpacing: '0.3em' }}>&lt;
                    专利证书&gt;</div>
            </div>,

            <Footer1
                id="Footer1_0"
                key="Footer1_0"
                dataSource={Footer10DataSource}
                isMobile={this.state.isMobile}
            />,
        ];
        return (
            <div
                className="templates-wrapper"
                ref={(d) => {
                    this.dom = d;
                }}
            >
                {/* 如果不是 dva 2.0 替换成 {children} start */}
                {children}
                {/* 如果不是 dva 2.0 替换成 {children} end */}
            </div>
        );
    }
}
